var _style, _defs, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUseAppContainerIos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "use-app-container-ios_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 490 650",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".use-app-container-ios_svg__st1{fill:#dadada}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "use-app-container-ios_svg__SVGID_1_",
    d: "M0 0h490v650H0z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "use-app-container-ios_svg__SVGID_00000087385032364908851510000003945400540826544303_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#use-app-container-ios_svg__SVGID_1_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#use-app-container-ios_svg__SVGID_00000087385032364908851510000003945400540826544303_)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "use-app-container-ios_svg__st1",
    d: "M410.4 0H79.6C35.7 0 0 35.7 0 79.6v584.7c0 44 35.7 79.6 79.6 79.6h330.7c44 0 79.6-35.7 79.6-79.6V79.6C490 35.7 454.3 0 410.4 0zm54.4 644.5c0 38.4-31.1 69.5-69.5 69.5H93.5C55.1 714 24 682.9 24 644.5v-551C24 55.1 55.1 24 93.5 24h301.7c38.4 0 69.5 31.1 69.5 69.5v551z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "use-app-container-ios_svg__st1",
    d: "M296.7 40H193.3c-10.7 0-19.3 8.6-19.3 19.3s8.6 19.3 19.3 19.3h103.3c10.7 0 19.3-8.6 19.3-19.3S307.3 40 296.7 40z"
  }))));
}
export default SvgUseAppContainerIos;